import { validateEmailAddress } from "@smartsuite/email-validation";
import normalizeUrl from "normalize-url";
export function getCurrentLinkData(state) {
    const { $cursor } = state.selection;
    if (!$cursor) {
        return null;
    }
    const link = state.doc.nodeAt($cursor.pos);
    if (!link) {
        return null;
    }
    const mark = getMark(link, state.schema.marks.link);
    if (!mark) {
        return null;
    }
    const from = $cursor.pos - $cursor.textOffset;
    const to = from + link.nodeSize;
    return { from, to, mark };
}
function getMark(node, markType) {
    return node.marks.find((m) => m.type === markType);
}
export function isExternalLink(link) {
    return !link.startsWith("#");
}
export function shouldAddProtocolPrefix(link) {
    const regExp = /^https?:\/\//i;
    return !regExp.exec(link);
}
export function normalizeLink(link) {
    // handle internal link (e.g. for toc) and email link
    if (link.startsWith("#") || link.startsWith("mailto:")) {
        return link;
    }
    if (link.includes("@") && validateEmailAddress(link)) {
        return `mailto:${link}`;
    }
    try {
        return normalizeUrl(link, {
            removeTrailingSlash: false,
        });
    }
    catch (_a) {
        return link;
    }
}
export const isValidProtocol = (link) => {
    const allowedProtocols = ["http:", "https:"];
    // eslint-disable-next-line n/no-unsupported-features/node-builtins
    return allowedProtocols.includes(new URL(link).protocol);
};
